import { ReactNode } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';

interface ModalBoxInterface {
    open: boolean;
    handleCloseModal: () => void;
    title: string;
    children?: ReactNode;
    widthSize?: string;
}

export const ModalBox = ({
    open,
    handleCloseModal,
    title,
    widthSize = '540px',
    children,
}: ModalBoxInterface) => {
    return (
        <Dialog
            open={open}
            onClose={handleCloseModal}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{ sx: { width: widthSize } }}
            maxWidth="xl"
            sx={{
                '.MuiPaper-root': { borderRadius: '20px', m: 0, p: 0 },
                marginX: 2,
            }}
        >
            <BootstrapDialogTitle id="customized-dialog-title" onClose={handleCloseModal}>
                <Typography sx={{ fontSize: '24px' }}>{title}</Typography>
            </BootstrapDialogTitle>
            <DialogContent sx={{ overflowX: 'hidden' }}>{children}</DialogContent>
        </Dialog>
    );
};

export interface DialogTitleProps {
    id: string;
    children?: ReactNode;
    onClose: () => void;
}

const BootstrapDialogTitle = (props: DialogTitleProps) => {
    const { children, onClose, ...other } = props;
    return (
        <DialogTitle
            sx={{
                m: 0,
                p: 2.5,
                borderRadius: '20px 20px 0 0',
                backgroundImage: 'linear-gradient(to right, #FF8008, #FFC837)',
                color: '#fff',
            }}
            {...other}
        >
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 15,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon
                        sx={{
                            backgroundColor: '#fff',
                            border: 'thin solid #F39E4E',
                            borderRadius: '50%',
                            color: '#F39E4E',
                            width: '30px',
                            height: '30px',
                        }}
                    />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};
